import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { IJBPActualsAndTargetsCategory } from 'legacy/lut/services/partner360/common/models/jbpActualsAndTargetsCategories'

import { IMappedProductTreeItem } from 'partner360/components/filters'

export const KEY_INITIATIVE_FORM_KEY = 'KEY_INITIATIVE_FORM'
export const PARENT_KEY_INITIATIVE_FORM_KEY = 'PARENT_KEY_INITIATIVE_FORM'

export { INITIATIVES_EDITOR_TYPES } from 'partner360/features/keyInitiativeEditor/model/editorConfig'

export const EXTENDED_BUSINESS_UNITS_PS: IJBPActualsAndTargetsCategory[] = [
  {
    EntryId: 1,
    Category: 'Alliance',
    CategoryTranslation: 'Alliance',
    ProgramType: ProgramTypes.PersonalSystems,
  },
  {
    EntryId: 2,
    Category: 'PS',
    CategoryTranslation: 'PS',
    ProgramType: ProgramTypes.PersonalSystems,
  },
  {
    EntryId: 3,
    Category: 'WS',
    CategoryTranslation: 'WS',
    ProgramType: ProgramTypes.PersonalSystems,
  },
]

export const EXTENDED_BUSINESS_UNITS_PRINT: IJBPActualsAndTargetsCategory[] = [
  {
    EntryId: 1,
    Category: 'Print',
    CategoryTranslation: 'Print',
    ProgramType: ProgramTypes.CorePrint,
  },
  {
    EntryId: 2,
    Category: 'Supplies',
    CategoryTranslation: 'Supplies',
    ProgramType: ProgramTypes.CorePrint,
  },
  {
    EntryId: 3,
    Category: 'WS',
    CategoryTranslation: 'WS',
    ProgramType: ProgramTypes.CorePrint,
  },
]

export const EXTENDED_BUSINESS_UNITS_BLANK: IJBPActualsAndTargetsCategory[] = [
  {
    EntryId: 100,
    Category: 'Blank',
    CategoryTranslation: 'Blank',
    ProgramType: ProgramTypes.CorePrint,
  },
]

export const EXTENDED_FOCUS_AREA: IMappedProductTreeItem[] = [
  {
    itemId: 'SmartBuy',
    parentId: 'Core Print',
    name: 'SmartBuy',
    order: 100,
  },
]

export const PRACTICE_DEVELOPMENT = 'Practice Development'
// Only nodes without children can be selected, at any depth of the SI tree.
export const SELECT_ONLY_LEAF_STRATEGIC_INITIATIVES = true
// Used when the flag above is false: only these root items remain non-selectable.
export const NON_SELECTABLE_ROOT_STRATEGIC_INITIATIVES: readonly string[] = [PRACTICE_DEVELOPMENT]
// With one root, true opens every branch to its leaves; false opens just the root.
export const EXPAND_SINGLE_ROOT_TO_LEAVES = false

export const IS_VALIDATE_ON_OPENING = false
export const IS_INCREMENTAL_MODE_LOCKED_BY_FUNDING_SOURCE = false

export type TProgressViewItem = {
  key: string
  order: number
}

export const PROGRESS_VIEW_KEY = 'jbp-key-initiatives-progress-view'
export const PROGRESS_VIEW_LABEL_SUFFIX = '-label'
export const PROGRESS_VIEW_DESC_SUFFIX = '-desc'
export const PROGRESS_VIEW_ITEMS: TProgressViewItem[] = [
  {
    key: `${PROGRESS_VIEW_KEY}-commitment`,
    order: 0,
  },
  {
    key: `${PROGRESS_VIEW_KEY}-jointoffer`,
    order: 1,
  },
  {
    key: `${PROGRESS_VIEW_KEY}-capabilities`,
    order: 2,
  },
  {
    key: `${PROGRESS_VIEW_KEY}-delivery`,
    order: 3,
  },
  {
    key: `${PROGRESS_VIEW_KEY}-pipeline`,
    order: 4,
  },
  {
    key: `${PROGRESS_VIEW_KEY}-referencecases`,
    order: 5,
  },
]
